import type { PlaceholderDataFunction } from '@tanstack/react-query';
import { hashKey } from '@tanstack/react-query';

export function createPlaceholderDataHandler<T>(key: string[]): PlaceholderDataFunction<T> {
    return (previousData, previousQuery) => {
        if (hashKey(key) === previousQuery?.queryHash) {
            return previousData;
        }

        return undefined;
    };
}
